/* global axios */
// Administrators grant or remove the Squareme team lead role.
const base = accountId => `/api/v1/accounts/${accountId}/team_leads`;

export const grantTeamLead = (accountId, userId) =>
  axios.post(base(accountId), { user_id: userId }).then(r => r.data);

export const revokeTeamLead = (accountId, userId) =>
  axios.delete(`${base(accountId)}/${userId}`).then(r => r.data);
